import { EXPAND_ADDRESS, SLOW_COLLAPSE_ADDRESS, FAST_COLLAPSE_ADDRESS, FOCUS_TO_ELEMENT_WAIT_TIME } from './CollapsibleAddressFieldsConstants';
export const expandAddress = (val) => {
    return {
        type: EXPAND_ADDRESS,
        payload: val
    };
};

export const collapseAddressImmediately = (val) => {
    return {
        type: FAST_COLLAPSE_ADDRESS,
        payload: val
    };
};

export const collapseAddressSlowly = (val) => {
    return {
        type: SLOW_COLLAPSE_ADDRESS,
        payload: val
    };
};

export const forceFocus = (id) => {
    setTimeout(() => {
        try {
            document.getElementById(id).focus();
        } catch (err) {
            //no op
        }
    }, 1000);

};


